import { AspectRatio, Button, Col, Row, Container } from '@ag1/ui';

const ContainerDuplicateStyles = () => (
  <div style={{ display: 'none', overflow: 'hidden', visibility: 'hidden' }}>
    <Container>
      <Row>
        <Col>
          <AspectRatio> </AspectRatio>
          <Button> </Button>
        </Col>
      </Row>
    </Container>
  </div>
);

export default ContainerDuplicateStyles;
